import { Sites } from '@ps/platform-message-framework/common/Sites';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation } from '@ps/web-shared-components';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import PhoneVerification from '@swf/components/PhoneVerification/PhoneVerification';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import CheckGreen from '../../../../assets/icons/check-green.svg';
import useRmfFirstScreenBackButton from '../../../../hooks/useRmfFirstScreenBackButton';
import Alert from '../../../Alert/Alert';
import Container from '../../../Container/Container';
import DialingCode from '../../../DialingCode/DialingCode';
import useTransitionScreenHandler from '../../hooks/useTransitionScreenHandler';
import RMFFeedbackButton from '../RMFFeedback/RMFFeedbackButton';
import RMFTransitionScreen from '../RMFTransitionScreen/RMFTransitionScreen';

import {
  TXTCLI_Your_number,
  TXTWCL_Contact_Details,
  TXTWCL_If_your_mobile_number_is_on_th_ELL,
  TXTWCL_WhatXs_your_phone_numberX,
  TXTWCL_You_must_contact_your_Network__ELL
} from './RMFPhone.messages.json';
import { info } from './RMFPhone.scss';

const RMFPhone: React.FC = () => {
  const swcRMFPhoneVerification = useFeature(FeatureFlag.SwcRMFPhoneVerification);
  const isAutofocusEnabled = useFeature(FeatureFlag.SwcSignupRmfAutofocus);
  const [callingCode, setCallingCode] = useState<string>('');
  const [shouldAutoFocus, setShouldAutoFocus] = useState<boolean>(false);
  const [isTransitionVisible, closeTransitionScreen] = useTransitionScreenHandler();
  const { showBackButton, handleClick } = useRmfFirstScreenBackButton();
  const site = useSelector(select.cms.getSiteId);
  const {
    data: { cmsHeaderAndGridLayout }
  } = useWizardContext();

  useEffect(() => {
    if (isTransitionVisible !== undefined) {
      setShouldAutoFocus(isAutofocusEnabled && !isTransitionVisible);
    }
  }, [isAutofocusEnabled, isTransitionVisible]);

  return (
    <Container
      page={RMFPhone}
      headerProps={{
        title: (
          <Translation
            {...(swcRMFPhoneVerification ? TXTWCL_Contact_Details : TXTCLI_Your_number)}
          />
        ),
        buttons: { back: showBackButton, onBackClick: handleClick }
      }}
      pageTopTitle={<Translation {...TXTWCL_WhatXs_your_phone_numberX} />}
    >
      {isTransitionVisible && <RMFTransitionScreen handleButtonClick={closeTransitionScreen} />}
      {site === Sites.DE && (
        <Alert variant="info" className={info}>
          <Translation {...TXTWCL_If_your_mobile_number_is_on_th_ELL} />{' '}
          <Translation {...TXTWCL_You_must_contact_your_Network__ELL} />
        </Alert>
      )}
      <PhoneVerification.VerifyNumber
        callingCode={callingCode}
        first
        autoFocus={shouldAutoFocus}
        fieldName="mobilePhoneNumber"
        {...(cmsHeaderAndGridLayout && { gridLayout: true })}
        icon={<CheckGreen />}
      >
        <DialingCode setCallingCode={setCallingCode} />
      </PhoneVerification.VerifyNumber>
      <RMFFeedbackButton />
    </Container>
  );
};

RMFPhone.displayName = 'RMFPhone';

export default RMFPhone;
